module.exports = __webpack_public_path__ + "static/img/Home2.683f7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home2.png
// module id = jecc
// module chunks = 1